export const APP_NAME = "Cowallet";
